<script setup lang="ts">
  import { type Component } from 'vue';

  export interface TabPanelProps {
    /**
     * The identifier for the Tab component that this panel is associated with.
     */
    tabValue: string;

    /**
     * The currently active tab value
     */
    activeTab: string;

    /**
     * The tag name or component to render.
     *
     * @default 'div'
     * @see: https://vuejs.org/api/built-in-special-elements.html#component
     */
    is?: string | Component;
  }

  const props = withDefaults(defineProps<TabPanelProps>(), {
    is: 'div',
  });
</script>

<template>
  <component
    :is="props.is"
    :id="`tabpanel-${props.tabValue}`"
    data-test="stash-tab-panel"
    :class="['stash-tab-panel', { hidden: props.activeTab !== props.tabValue }]"
    role="tabpanel"
  >
    <slot></slot>
  </component>
</template>
